<template>
	<div class="footer mt-10" :style="paddingBottom">
		<v-container class="py-12">
			<v-row>
				<v-col cols="12" md="4">
					<h3 v-html="$processText(__('footer_contact_title'))"></h3>

					<div v-html="$processText(__('footer_contact'))"></div>
				</v-col>

				<v-col cols="12" md="4">
					<div v-if="sent"> 
						<h3>Tack för din feedback!</h3>
					</div>

					<div v-if=" ! sent">
						<p class="error" v-if="errors.find(e => e.field === 'email')">Du måste fylla i en giltig e-post.</p>
						<v-text-field class="mb-4" :error="errors.find(e => e.field === 'email')" ref="to" v-model="email" hide-details :label="__('footer_form_email')" placeholder=" " outlined></v-text-field>

						<p class="error" v-if="errors.find(e => e.field === 'feedback')">Du måste fylla i ett meddelande.</p>
						<v-textarea ref="to" :error="errors.find(e => e.field === 'feedback')" class="mb-4" hide-details v-model="feedback" :label="__('footer_form_feedback')" placeholder=" " outlined></v-textarea>

						<div class="text-right">
							<div class="btn form" @click="sendFeedback()" v-html="__('footer_form_button')"></div>
						</div>
					</div>
				</v-col>

				<v-col cols="12" md="4" class="footer-logos text-center text-lg-right">
					<div class="service-resvana-logo">
						<h3 v-html="__('footer_bottom_service', 'Tjänsten')" class="service-resvana-text"></h3>
						<a href="https://resvana.com" target="_blank">
							<img class="resvana-logo" src="@/assets/img/footer-resvana.png" width="148">
						</a>
					</div>

					<div class="delivered-by-nudgd-logo">
						<h3 v-html="__('footer_bottom_delivered_by', 'Levereras av')" class="delivered-by-nudgd-text"></h3>
						<a href="https://nudgd.se" target="_blank">
							<img class="resvana-logo nudgd-logo" src="@/assets/img/footer-nudgd.png" width="123">
						</a>
					</div>

					<div class="mission-by-client-logo">
						<h3 v-html="__('footer_bottom_mission_by', 'På uppdrag av')" class="mission-by-client-text"></h3>

						<a target="_blank" v-if="client.url" :href="client.url"><img class="nudgd-logo" :src="$imgUrl(client.logo)"></a>

						<img v-if=" ! client.url" class="nudgd-logo" :src="$imgUrl(client.logo)">
					</div>
				</v-col>
			</v-row>
		</v-container>

		<div class="footer-bottom">
			<v-container class="py-8">
				<v-row>
					<v-col cols="12" sm="6" class="footer-integrity">
						<div v-if="client.footer_wysiwyg" v-html="$processText(client.footer_wysiwyg)"></div>

						<template v-if=" ! client.footer_wysiwyg">
							<h3 v-html="__('footer_integrity_title')"></h3>
							<div v-html="__('footer_integrity')"></div>
						</template>
					</v-col>

					<v-col cols="12" sm="6"  class="footer-bookmark">
						<h3 v-html="__('footer_bookmark_title')"></h3>
						<div v-html="__('footer_bookmark')"></div>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'Footer',
    props: [],

    data() {
    	return {
			email: null,
			feedback: null,
			sent: false,
			errors: []
    	}
    },

    methods: {
    	validateFeedback() {
    		this.errors = []

    		if (this.email) {
    			if ( ! /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
    				this.errors.push({field: 'email', message: 'Du måste fylla i en giltig e-post.'})
    			}
    		}

    		if ( ! this.feedback || ! this.feedback.trim()) {
    			this.errors.push({field: 'feedback', message: 'Du måste fylla i ett meddelande.'})
    		}

    		return this.errors.length === 0
    	},

    	sendFeedback() {
    		if ( ! this.validateFeedback()) {
    			return
    		}

			axios
				.post(this.$apiUrl + '/api/feedback/' + this.$route.params.slug, {
					feedback: {
						email: this.email,
						feedback: this.feedback
					}
				})
				.then(res => this.sent = true)

			this.$metric({'event': 'form_submit'})
    	}
    },

    computed: {
    	paddingBottom() {
    		if (this.$store.state.filterOpen && this.$store.state.filterHeight > 30) {
    			return {'padding-bottom': this.$store.state.filterHeight + 'px'}
    		}

    		return null
    	},

		client() {
			return this.$store.state.client
		},
    }
}
</script>
